import { clsx } from 'clsx';

import type ICheckbox from './interfaces/ICheckbox';

import styles from './scss/Checkbox.module.scss';

function Checkbox({
  value,
  checked,
  onChange,
  name,
  label,
  disabled,
  type = 'checkbox',
  isLineMark,
  showSquare,
  icon,
  className,
  size = 'default',
  inputAriaLabel,
}: ICheckbox) {
  const isRadioButton = type === 'radio';

  return (
    <label
      className={clsx(styles.root, {
        [styles.medium]: size === 'medium',
        [styles.small]: size === 'small',
      }, className)}
      htmlFor={name}
    >
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      {label}
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        aria-label={inputAriaLabel}
      />
      <span className={isRadioButton ? styles.radio : clsx(styles.checkmark, {
        [styles.lineMark]: isLineMark,
        [styles.squareMark]: showSquare,
      })}
      />
    </label>
  );
}

export default Checkbox;
